import * as Types from '../actions/Supplier/SupplierActionTypes';

const initialState = [];

const supplierReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
    case Types.CREATE_SUPPLIER:
        console.log('CREATE_SUPPLIER called with data', payload);
        return [...state, payload];
    case Types.READ_SUPPLIER:
        console.log('reducer called with data', payload);
        return payload.suppliers;
    case Types.UPDATE_SUPPLIER:
        console.log('UPDATE_SUPPLIER called with data', payload);
        return payload.supplier;
    case Types.DELETE_SUPPLIER:
        return state.filter((supplier) => supplier.supplier_id !== payload);
    case Types.GET_PRODUCT_FOR_SUPPLIER:
        console.log('reducer called with data', payload);
        if (payload.supplier_id === 0) return payload.products;
        return payload.products;
    case Types.GET_PRODUCT_BY_ID_FOR_SUPPLIER:
        console.log('reducer called with data', payload);
        if (payload.supplier_id === 0) return payload.products;
        return payload.products;
    case Types.CREATE_PRODUCT_BY_SUPPLIER:
        console.log('CREATE_product called with data', payload.products);
        return [...state, payload.products];
    case Types.DELETE_PRODUCT_BY_SUPPLIER:
        return state.filter((product) => product.product_id !== payload);
    case Types.UPDATE_PRODUCT_BY_SUPPLIER:
        console.log('UPDATE_PRODUCT_BY_SUPPLIER called with data', state, payload);
        return state.map((prod) => (prod.productId === payload.product_id ? payload.products : prod));
    default:
        return state;
    }
};

export default supplierReducer;
